<template>

  <v-container fluid fill-height class="p-appy-welcome pa-0 ma-0">
    <v-layout
      justify-center
      align-center
      row
      fill-height
      class="p-appy-background"
    >
      <v-flex xs10 md8 lg5 xl4 class="appy-blur">
        <v-card flat class="pt-2 pb-4 mx-0 transparent" max-width="500">
          <v-card-title primary-title class="align-center justify-center">
            <div>
              <div class="font-raleway appy-header pa-1 appy-text-shadow-white">NEW: DIGITAL INVITES</div>
            </div>
          </v-card-title>
          <v-card-text>
            <p class="font-open_sans appy-subhead-1 px-4 py-1">Send beautiful digital Announcements, Save The Dates, Invites and Thank You’s to your guests.</p>
            <p class="font-open_sans appy-subhead-1 px-4 py-1">Choose and edit existing templates or create your own from scratch. The possibilities are endless.</p>
            <p class="font-open_sans appy-subhead-1 px-4 py-1">Included for free with your Appy account.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="dataLoggedIn" to="/editor/appystudio/welcome/select" color="appy-color gray-1" large dark><span class="font-raleway appy-header appy-sm">GET STARTED</span></v-btn>
            <v-btn v-else href="/signup/" color="appy-color gray-1" large dark><span class="font-raleway appy-header appy-sm">SIGN UP</span></v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import DefaultAppyComponent from '~/src/mixins/DefaultAppyComponent'
  import { mapState } from 'vuex'

  export default {
    name: "Index",
    layout: 'appystudiotopbar',
    mixins: [DefaultAppyComponent],
    created() {
      let authToken = this.$cookies.get('al')
      if (typeof authToken !== 'undefined' && authToken !== null && authToken.length > 1) {
        this.dataLoggedIn = true;
      }
    },
    computed: {
      ...mapState({
        theme: state => state.emailEditor.theme,
        eventData: state => state.emailEditor.eventData,
        userSession: state => state.user.session
      }),
    },
    props: {},
    data() {
      return {
        dataLoggedIn: false
      }
    }
  }
</script>
<style lang="scss">
  .p-appy-background {
    background: url('~assets/img/email_editor/general/appystudio-welcome-bckg.jpg') fixed no-repeat;
    background-size: cover;
  }
</style>
